/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export const TROY_HELP_CENTER_LINKS_V2 = {
  SG: "https://help.grab.com/merchant/en-sg/360001717951",
  MY: "https://help.grab.com/merchant/en-my/360001717951",
  ID: "https://help.grab.com/merchant/id-id/360001717951",
  TH: "https://help.grab.com/merchant/th-th/360001717951",
  VN: "https://help.grab.com/merchant/vi-vn/360001717951",
  PH: "https://help.grab.com/merchant/en-ph/360001717951",
  MM: "https://help.grab.com/merchant/my-mm/360001717951",
}

export const REPORT_POLICY_LINK =
  "https://help.grab.com/merchant/en-sg/4408080591001"

export const TROY_ORDER_MANAGER_HELP_CENTER_LINKS = {
  SG: "https://help.grab.com/merchant/en-sg/360004458172",
  MY: "https://help.grab.com/merchant/ms-my/360004458172",
  TH: "https://help.grab.com/merchant/th-th/360004458172",
  VN: "https://help.grab.com/merchant/vi-vn/360004458172",
  ID: "https://help.grab.com/merchant/id-id/360004458172",
  PH: "https://help.grab.com/merchant/en-ph/360004458172",
  MM: "https://help.grab.com/merchant/my-mm/360004458172",
  KH: "https://help.grab.com/merchant/km-kh/360004458172",
}

export const TROY_ORDER_MANAGER_HELP_CENTER_LINKS_STAGING = {
  SG: "https://help.stg-myteksi.com/merchant/en-sg/360004458172",
  MY: "https://help.stg-myteksi.com/merchant/ms-my/360004458172",
  TH: "https://help.stg-myteksi.com/merchant/th-th/360004458172",
  VN: "https://help.stg-myteksi.com/merchant/vi-vn/360004458172",
  ID: "https://help.stg-myteksi.com/merchant/id-id/360004458172",
  PH: "https://help.stg-myteksi.com/merchant/en-ph/360004458172",
  MM: "https://help.stg-myteksi.com/merchant/my-mm/360043083572",
  KH: "https://help.stg-myteksi.com/merchant/km-kh/360004458172",
}
